import { FEATURE_FLAGS, FeatureFlags } from '../types/featureFlags';
import { FormattedTemplate } from '../types/templates';
import { isFeatureEnabled } from './feature-util';

/**
 * Extract structured context from the selected template for document generation.
 * For HTML templates, this extracts sections with HTML data from the template's context.
 */
export const extractStructuredContext = (
  selectedTemplate: FormattedTemplate | undefined,
  featureFlags: FeatureFlags | undefined
):
  | { sections: Array<{ key: string; value: unknown }> }
  | Record<string, unknown>
  | undefined => {
  if (!isFeatureEnabled(featureFlags, FEATURE_FLAGS.CUSTOM_TEMPLATES)) {
    return undefined;
  }

  if (!selectedTemplate?.isHostProvided) {
    return undefined;
  }

  // For host-provided templates, extract structured context from the template's root context
  const structuredContext = selectedTemplate.context?.structured;

  return structuredContext;
};